import { endPoints, Params } from '@/shared/types/api';
import { ActionType } from '..';
import { DOCUMENT_ACTION } from './actionTypes';
import { axios } from '@/plugins/axios';
import { DOCUMENT_MUTATION } from '../mutations/mutationTypes';
import { useNotification } from '@/shared/hooks/useNotification';

const config = {
  headers: {
    'content-type': 'multipart/form-data',
  },
};

export const documentActions = {
  [DOCUMENT_ACTION.GET_OFFICIAL_DOCUMENT]: (
    { commit }: ActionType,
    payload: Params<'getOfficialDocument'>,
  ) => {
    axios
      .get(endPoints.getOfficialDocument.endPoint, { params: payload })
      .then((res) => {
        commit(DOCUMENT_MUTATION.GET_OFFICIAL_DOCUMENT, res.data);
      });
  },
  [DOCUMENT_ACTION.SAVE_OFFICIAL_DOCUMENT]: (
    { commit }: ActionType,
    payload: Params<'saveOfficialDocument'>,
  ) => {
    axios
      .post(endPoints.saveOfficialDocument.endPoint, payload, config)
      .then((res) => {
        commit(DOCUMENT_MUTATION.GET_OFFICIAL_DOCUMENT, res.data);
      });
  },
  [DOCUMENT_ACTION.GET_RESULT_DOCUMENT]: (
    { commit }: ActionType,
    payload: Params<'getResultPublicationDocument'>,
  ) => {
    axios
      .get(endPoints.getResultPublicationDocument.endPoint, { params: payload })
      .then((res) => {
        commit(DOCUMENT_MUTATION.GET_RESULT_DOCUMENT, res.data);
      });
  },
  [DOCUMENT_ACTION.SAVE_RESULT_DOCUMENT]: (
    { commit }: ActionType,
    payload: Params<'saveResultPublicationDocument'>,
  ) => {
    const { showNotification } = useNotification();

    axios
      .post(endPoints.saveResultPublicationDocument.endPoint, payload, config)
      .then((res) => {
        showNotification({
          isShow: true,
          message: 'ファイルを登録しました',
          type: 'success',
        });
        commit(DOCUMENT_MUTATION.GET_RESULT_DOCUMENT, res.data);
      })
      .catch((e) => {
        return e;
      });
  },
};
